// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"702e9d2e","453":"471be90a","455":"3576e828","977":"f9faa957"}[chunkId] + ".chunk.js";
};